export default __webpack_public_path__ + "static/media/go_go.df42a03a.mp3";